import Vehicles from '../../../../components/customer/vehicles/Vehicles'

const AEACustomerVehicles = () => {
    return <Vehicles />
}

export default AEACustomerVehicles
